<template>
  <div class="ll-state-list">
    <div class="ll-state-list__content">
      <div
        v-for="(state,stateIndex) in stateList"
        :key="stateIndex"
        class="ll-state-list__content-item"
      >
        <div
          v-if="state.multiple"
          class="ll-state-list__content-item-multiple"
        >
          <LlState
            v-for="(item,itemIndex) in state.list"
            :key="itemIndex"
            v-model="C_value[itemIndex]"
            :is-required="item.required"
            :type="item.type"
            :placeholder="item.placeholder"
            :title="item.title"
            :rules="item.rules"
            :leading-icon="item.leadingIcon"
            :has-check-box="item.hasCheckBox"
            :is-check-box-select="item.isCheckBoxSelect"
            :checkbox-text="item.checkboxText"
            :select-value="item.selectValue"
            :remind-text="item.remindText"
            :before-text="item.beforeText"
            :after-text="item.afterText"
            :dropdown-menu-items="item.dropdownMenuItems"
            :is-disabled="item.isDisabled"
            :is-outline="item.isOutline"
            @checkbox-select="$_checkBoxSelect($event,item)"
          />
        </div>
        <LlState
          v-else
          v-model="C_value[stateIndex]"
          :is-required="state.required"
          :type="state.type"
          :placeholder="state.placeholder"
          :title="state.title"
          :rules="state.rules"
          :leading-icon="state.leadingIcon"
          :has-check-box="state.hasCheckBox"
          :is-check-box-select="state.isCheckBoxSelect"
          :checkbox-text="state.checkboxText"
          :select-value="state.selectValue"
          :remind-text="state.remindText"
          :before-text="state.beforeText"
          :after-text="state.afterText"
          :dropdown-menu-items="state.dropdownMenuItems"
          :is-disabled="state.isDisabled"
          :is-outline="state.isOutline"
          @checkbox-select="$_checkBoxSelect($event,state)"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlStateList",
  props: {
    stateList: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    selectValue: {},
  },
  data: () => ({
    C_value: {},
  }),
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.C_value = this.value;
      },
    },
    C_value: {
      deep: true,
      handler() {
        this.$emit("input", this.C_value);
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-state-list";
</style>